import { render, staticRenderFns } from "./creatAccount.vue?vue&type=template&id=47e86343&scoped=true"
import script from "./creatAccount.vue?vue&type=script&lang=js"
export * from "./creatAccount.vue?vue&type=script&lang=js"
import style0 from "./creatAccount.vue?vue&type=style&index=0&id=47e86343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e86343",
  null
  
)

export default component.exports